import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';

import { AppComponent } from './app.component';
import { HelloComponent } from './hello.component';
import { CompileDirective } from './compile.directive';
import { QRCodeModule } from 'angularx-qrcode';

@NgModule({
  imports:      [ BrowserModule, FormsModule,QRCodeModule ],
  declarations: [ AppComponent, HelloComponent, CompileDirective ],
  bootstrap:    [ AppComponent ]
})
export class AppModule { }
